import {Button, ModalCard} from "@vkontakte/vkui";
import {observer} from "mobx-react-lite";
import React from "react";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {InviteButton} from "../../components/InviteButton/InviteButton";
import GameStore from "../../store/game";
import {
    MODAL_CARD_CLASS,
    MODAL_HEADER_CLASS,
    MODAL_INNER_CARD_CLASS,
    MODAL_SECONDARY_BUTTON_CLASS,
    MODAL_SUBHEADER_CLASS
} from "../modalStyles";

// Итоговое модальное окно для текущей игры
export const GameResultModal = observer(({nav}) => {
    const routeNavigator = useRouteNavigator();
    const foundWords = Array.isArray(GameStore.foundWords) ? GameStore.foundWords : [];

    const stats = [
        {label: "Счёт", value: GameStore.score, accent: "text-gray-900", hint: "Очки за собранные слова"},
        {label: "Собрано слов", value: foundWords.length, accent: "text-gray-900", hint: "Сколько слов успели собрать"},
    ];

    const closeModal = () => routeNavigator.hideModal();

    return (
        <>
            <ModalCard
                nav={nav}
                onClose={closeModal}
                className={MODAL_CARD_CLASS}
                header={<span className={MODAL_HEADER_CLASS}>Итоги игры</span>}
                subheader={<span className={MODAL_SUBHEADER_CLASS}>Время вышло — вот что удалось собрать.</span>}
                actions={
                    <div className="flex flex-col w-full gap-2">
                        <InviteButton/>
                        <Button
                            size="l"
                            mode="secondary"
                            className={MODAL_SECONDARY_BUTTON_CLASS}
                            onClick={closeModal}
                        >
                            Продолжить
                        </Button>
                    </div>
                }
            >
                <div className="flex flex-col w-full gap-3 mt-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                        {stats.map(({label, value, accent, hint}) => (
                            <div
                                key={label}
                                className={`rounded-xl px-3 py-2 ${MODAL_INNER_CARD_CLASS}`}
                            >
                                <div className="text-xs text-gray-700">{label}</div>
                                <div className={`text-xl font-semibold ${accent}`}>{value}</div>
                                <div className="text-[11px] text-gray-700">{hint}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </ModalCard>
        </>
    );
});
